module.exports = __webpack_public_path__ + "img/sign_220320572_1.6021f8cb.png";